import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MaxPainel } from '../models/max-painel';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class MaxPainelService {

  constructor(
    private http: HttpClient,
  ) { }

  salvar(maxPainel: MaxPainel) {
    return this.http.post(globals.apiUrl + '/api/MaxPainel/Salvar', maxPainel);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/MaxPainel/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarMaxPainel(id: number) {
    return this.http.get<MaxPainel>(globals.apiUrl + '/api/MaxPainel/Buscar', {
      params: new HttpParams()
        .set('id', id.toString())
    });
  }

  consultarLista() {
    return this.http.get<MaxPainel[]>(globals.apiUrl + '/api/MaxPainel/Lista');
  }

  consultarMaxPainelComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    return this.http.get<any>(globals.apiUrl + '/api/MaxPainel/ListaPag',
      {
        params: parametros
      });
  }
}
